import { FormSchema } from "lib/types";
import { EditProfileFields } from "./types";

export const editProfileSchema: FormSchema<keyof typeof EditProfileFields>[] = [
  {
    name: EditProfileFields.first_name,
    label: 'First name',
    type: 'text',
    placeholder: 'First name',
    isRequired: true,
    spellCheck: 'false',
  }, {
    name: EditProfileFields.last_name,
    label: 'Last name',
    type: 'text',
    placeholder: 'Last name',
    isRequired: true,
    spellCheck: 'false',
  },
  {
    name: EditProfileFields.email,
    label: 'Email',
    type: 'email',
    placeholder: 'Email',
    isRequired: true,
    spellCheck: 'false',
  }
];
